import { useQuery } from '@tanstack/react-query'
import { Star } from 'lucide-react'
import { api } from '@/lib/api'
import { cn } from '@/lib/utils'
import { Skeleton } from '@/components/ui/skeleton'

function Stars({ rating }: { rating: number }) {
  return (
    <div data-upbo-src="src/components/ReviewList.tsx:9" className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          className={cn('h-3.5 w-3.5', n <= rating ? 'fill-[#c98b7e] text-[#c98b7e]' : 'text-[#e0c8c1]')}
        />
      ))}
    </div>
  )
}

export default function ReviewList({ productId }: { productId: string }) {
  const reviews = useQuery({
    queryKey: ['reviews', productId],
    queryFn: () => api.products.reviews(productId),
    enabled: Boolean(productId),
  })

  if (reviews.isLoading) {
    return (
      <div data-upbo-src="src/components/ReviewList.tsx:29" className="space-y-4">
        {[0, 1].map((i) => <Skeleton key={i} className="h-24 rounded-xl" />)}
      </div>
    )
  }

  const rows = reviews.data ?? []
  if (rows.length === 0) {
    return <p data-upbo-src="src/components/ReviewList.tsx:37" className="text-sm text-[#9c7a72]">Chưa có đánh giá nào cho sản phẩm này.</p>
  }

  return (
    <ul data-upbo-src="src/components/ReviewList.tsx:41" className="space-y-4">
      {rows.map((review) => (
        <li data-upbo-src="src/components/ReviewList.tsx:43" key={review.id} className="rounded-xl border border-[#eedfda] bg-[#fdf8f6] p-5">
          <div data-upbo-src="src/components/ReviewList.tsx:44" className="flex items-center justify-between gap-4">
            <span data-upbo-src="src/components/ReviewList.tsx:45" className="text-sm font-medium text-[#5f3f38]">{review.author}</span>
            <Stars rating={Number(review.rating) || 0} />
          </div>
          <p data-upbo-src="src/components/ReviewList.tsx:48" className="mt-3 text-sm leading-relaxed text-[#9c7a72]">{review.content}</p>
        </li>
      ))}
    </ul>
  )
}
